import { render, staticRenderFns } from "./GooglePlayImage.vue?vue&type=template&id=318f8fa2&functional=true&"
import script from "./GooglePlayImage.vue?vue&type=script&lang=js&"
export * from "./GooglePlayImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports